import logo from "../assets/bestgamer/bg_logo.svg";
import small from "../assets/bestgamer/bg_logo_small.webp";
import appicon from "../assets/bestgamer/bg_appicon.webp";
import logo_white from "../assets/bestgamer/bg_sticker_2025_white_v2.webp";
import newsCover from "@/assets/cover/news_wog.webp";

export const BESTGAMER_brandVariables = {
  siteTitle: "Best Gamer",
  siteIcon: appicon,
  name: "Best Gamer",
  name_small: "BG",
  logos: {
    large: logo,
    white: logo_white,
    small: small,
    medium: null,
    alt_text: "Best Gamer logo",
    profile: null,
  },
  cover: {
    zones: newsCover,
  },
  tenantId: "bestgamer-nm3y2",
  brandTheme: "bg", // Theme of the brand
  site: "app.bestgamer.gg", // Live url of site
  authMethod: "email", // Only needed for events, gives user set options to manualy sign up, options are:  email | phone
  defaultCountryCode: "DK", // Only needed for retail platforms | For initial phone number | Changes all auth methods`
  defaultLanguage: "en",
  brandStoreExtension: "", // Only needed for retail platforms | Extension used for email
  brandValue: "BG", // Only needed for retail platforms | Brand value needed for BE related functions
  brandIntials: "", // gets added after the username, to drasticaly descrease chance of duplicate usernames across different apps | Only needed for event platforms
  defaultNavigateUrl: "/",
  eventHasAutoQrSignup: false,
  hasSubClients: false,
  subClientsForOverviews: null, // string[] of clients used to fetch multiple types of clients for overview pages
  autoJoinChallenge: false,
  hasFeature: {
    notifications: false,
    themes: false,
    connections: true,
    achievements: false,
    messages: false,
    teams: false,
    news: true,
    challenges: true,
    singleChallenge: true,
    preferences: false,
    friends: false,
    zones: true,
    feed: true,
    posts: false,
    winners: false, // !! Also add the data variables for this feature in brandVariables.tsx !!
    schedule: false, // !! Also add the data variables for this feature in brandVariables.tsx !!
    qrSignUp: false,
    manualSubmissions: false,
    landing: true,
    login: true,
    haslanguagePicker: true,
    getstarted: false,
    hero: false,
    search: false,
    routes: false,
    dailytasks: false,
    games: false,
    treasure_hunt: false,
    activities: false,
    changePassword: true,
    feedback: true,
    events: true,
  },
  hasAuth: {
    steam: false,
    bnet: false,
    quickSignUp: false,
    google: false,
    discord: true,
    twitch: false,
  },
  layout: {
    challenge: "default",
  },
  event: {
    forcedCredentialPopup: "email",
    eventCode: "", // Only needed for event platforms
    collectionForSubmissions: "",
    documentForSubmissions: "",
    isEvent: false,
    spacecoins_redirect: true,
  },
  hasCreate: {
    studio: true,
    challenges: true,
    news: true,
  },
};
